import { useState } from 'react'
import { ChatSuggestedFollowupsContent, ChatContextItem } from 'api/clients/ChatClient'
import { Text } from 'blaze-ui/Text/Text'
import { ArrowRightSm } from 'blaze-ui/icons/16'
import { useCreateMessage } from 'hooks/queries/chat/useCreateMessage'
import cx from 'classnames'
import Styles from './SuggestedFollowupsContent.module.scss'

interface SuggestedFollowupsContentProps {
  content: ChatSuggestedFollowupsContent
  threadId: number
  context?: ChatContextItem
  isDisabled: boolean
}

export const SuggestedFollowupsContent = ({
  content,
  threadId,
  context,
  isDisabled,
}: SuggestedFollowupsContentProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { mutate: createMessage, isError } = useCreateMessage()

  if (content.suggestions.length === 0) return null
  if (isSubmitting && !isError) return null

  const stripLeadingEmoji = (text: string) =>
    text.replace(/^[\p{Emoji_Presentation}\p{Extended_Pictographic}]\uFE0F?\s*/u, '')

  const handlePress = (suggestion: string) => {
    if (isDisabled) return

    setIsSubmitting(true)
    createMessage({
      threadId,
      content: [
        ...(context ? [{ type: 'context' as const, context }] : []),
        { type: 'text' as const, text: stripLeadingEmoji(suggestion) },
      ],
    })
  }

  return (
    <div className={Styles.root}>
      <div className={Styles.label}>
        <Text variant="secondary" color="var(--dark-60)">
          Suggested follow-ups
        </Text>
      </div>
      <div className={Styles.rows}>
        {content.suggestions.map((suggestion, index) => (
          <div
            key={`${index}-${suggestion}`}
            className={cx(Styles.row, { [Styles.disabled]: isDisabled })}
            onClick={() => handlePress(suggestion)}
            role="button"
            tabIndex={isDisabled ? -1 : 0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                handlePress(suggestion)
              }
            }}
            aria-disabled={isDisabled}
          >
            <Text variant="primary" color="var(--dark-90)">
              {suggestion}
            </Text>
            <ArrowRightSm color="var(--dark-40)" size={16} />
          </div>
        ))}
      </div>
    </div>
  )
}
